export const SET_POSTS = 'SET_POSTS'
export const SET_BUSY_TIMELINE = 'SET_BUSY_TIMELINE'

/**
 * Set timeline loading busy / unbusy
 *
 * @param {Object} state
 * @param {boolean} busy
 * @return {{busyPhotos: *}}
 */
function setBusyTimeline(state, busy) {
    return {
        ...state,
        busyTimeline: busy,
    }
}

/**
 * Set photos array into existing photos
 *
 * @param {Object} state
 * @param {array} posts
 * @param {boolean} append
 * @return {{photos: *[]}}
 */
function setPosts(state, posts, append = false) {
    return {
        ...state,
        posts: append ? [
            ...state.posts,
            ...posts,
        ] : posts,
    }
}

/**
 * Reducer for timeline
 * @param {Object} state
 * @param {Object} action
 * @returns {*}
 */
export default function reducer(state = [], action) {
    switch(action.type) {
        case SET_POSTS: return setPosts(state, action.posts, action.append || false)
        case SET_BUSY_TIMELINE: return setBusyTimeline(state, action.busy)
        default: return state
    }
}
